<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                员工审核
                <small>员工审核</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 员工审核
                    </a>
                </li>
                <li class="active">员工审核</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <!-- Main row -->
            <div class="row">
                <div class="col-sm-12">
                    <div id="atptoolbarAudit">
                        <!-- <button class="btn btn-info" type="button" id="sys_recordbutton">哈哈哈</button> -->
                    </div>
                    <table id="atptableAudit" data-show-columns="true"></table>
                </div>
            </div>
            <!-- /.row (main row) -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {}
    },
    components: {},
    mounted: function () {
      this.getlist()
    },
    methods: {
      getlist: function () {
        var self = this
        $('#atptableAudit').bootstrapTable({
          url: self.global.apiHost + 'employment/applications/', //请求后台的URL（*）
          method: 'get', //请求方式（*）
          ajaxOptions: {
            headers: {
              'content-type': 'application/json', // 默认值
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          },
          toolbar: '#atptoolbarAudit', //工具按钮用哪个容器
          height: $(window).height() * 0.9,
          striped: true, //是否显示行间隔色
          cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
          pagination: true, //是否显示分页（*）
          iconSize: 'outline',
          sortable: true, //是否启用排序
          sortName: 'stam_atpid',
          sortOrder: 'DESC',
          queryParams: self.queryParams, //传递参数（*）
          sidePagination: 'server', //分页方式：client客户端分页，server服务端分页（*）
          pageNumber: 1, //初始化加载第一页，默认第一页
          pageSize: 10, //每页的记录行数（*）
          pageList: [10], //可供选择的每页的行数（*）
          search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
          showColumns: true, //是否显示所有的列
          showRefresh: true, //是否显示刷新按钮
          minimumCountColumns: 2, //最少允许的列数
          clickToSelect: true, //是否启用点击选中行
          uniqueId: 'stam_atpid', //每一行的唯一标识，一般为主键列
          singleSelect: true,
          responseHandler: function (res) {
            return {
              total: res.length, //总页数
              rows: res //数据
            }
          },
          columns: [
            // { checkbox: true },
            {
              title: '序号',
              width: 40,
              formatter: function (value, row, index) {
                var option = $('#atptableAudit').bootstrapTable('getOptions')
                return option.pageSize * (option.pageNumber - 1) + index + 1
              }
            },
            {
              field: 'username',
              title: '申请人',
              sortable: true
            },
            {
              field: 'org',
              title: '申请公司',
              sortable: true
            },
            {
              title: '手机号',
              field: 'phone_number',
              sortable: true
            },
            {
              title: '申请时间',
              field: 'create_time',
              sortable: true
            },
            {
              title: '微信昵称',
              field: 'nick_name',
              sortable: true
            },
            {
              title: '微信头像',
              field: 'avatar_url',
              formatter: function (value, row, index) {
                return (
                  '<img src="' + value + '"/ style="width:80px;height:80px;">'
                )
              }
            },
            {
              title: '操作',
              field: 'id',
              formatter: function (value, row, index) {
                return (
                  '<button class="btn btn-success" data-id="' +
                  value +
                  '">通过</button>&nbsp;&nbsp;<button class="btn btn-danger" data-id="' +
                  value +
                  '">拒绝</button>'
                )
              }
            }
          ],
          onLoadSuccess: function () {
            // 通过审核
            $('#atptableAudit .btn-success').on('click', function () {
              var idd = $(this).attr('data-id')
              console.log('success', idd)
              // self,puturl,putData,callback,catchback
              self.global.axiosPut(
                self,
                'employment/application/' + idd + '/',
                { conclusion: 'pass' },
                function (res) {
                  alert('操作成功')
                  $('#atptableAudit').bootstrapTable('refresh')
                },
                function () {
                  alert('操作失败')
                }
              )
            })
            //拒绝申请
            $('#atptableAudit .btn-danger').on('click', function () {
              var idd = $(this).attr('data-id')
              console.log('danger', idd)
              self.global.axiosPut(
                self,
                'employment/application/' + idd + '/',
                { conclusion: 'fail' },
                function (res) {
                  alert('操作成功')
                  $('#atptableAudit').bootstrapTable('refresh')
                },
                function () {
                  alert('操作失败')
                }
              )
            })
          }
        })
      },
      pass: function () {
        console.log('passssss')
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/employeeAudit/employeeAudit.vue